<template>
    <div>
        <h2>Hello ini home</h2>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>

</style>